module.exports = {
  sliderData: () => {
    return {

      "TUCSON HEV": {
        name: "TUCSON HEV",
        nameTitle: "TUCSON Híbrida",
        nameAlt: "TUCSONHíbrida",
		    preview: require('./../UI/carSlider/tucson_car.webp'),
        info: require('./../UI/carSlider/kona_info.webp'),
        bgColor: '#444746'
      },
      "VENUE": {
        name: "VENUE",
        nameTitle: "VENUE",
        nameAlt: "VENUE",
		    preview: require('./../UI/carSlider/venue_car.webp'),
        info: require('./../UI/carSlider/venue_info.webp'),
        bgColor: '#a2a2a2'
      },
      "SANTA FE": {
        name: "SANTA FE",
        nameTitle: "SANTA FE Híbrida",
        nameAlt: "SANTAFEHíbrida",
		    preview: require('./../UI/carSlider/santafe_car.webp'),
        info: require('./../UI/carSlider/santafe_info.webp'),
        bgColor: '#6b4f46'
      },
      "KONA HEV": {
        name: "KONA HEV",
        nameTitle: "KONA Híbrida",
        nameAlt: "KONAHibrida",
		    preview: require('./../UI/carSlider/kona_car.webp'),
        info: require('./../UI/carSlider/kona_info.webp'),
        bgColor: '#2F3A4C'
      },
      
      // "CRETA": {
      //   name: "CRETA",
      //   nameTitle: "CRETA",
      //   nameAlt: "CRETA",
		  //   preview: require('./../UI/carSlider/creta_car.webp'),
      //   info: require('./../UI/carSlider/tucson_info.webp'),
      //   bgColor: '#b6b6b6'
      // },
      
      // "IONIQ 5": {
      //   name: "IONIQ 5",
      //   nameTitle: "IONIQ 5",
      //   nameAlt: "IONIQ5",
      //   preview: require('./../UI/carSlider/ioniq_car.webp'),
      //   info: require('./../UI/carSlider/ioniq_info.webp'),
      //   bgColor: '#A19E89'
      // },
	    // "PALISADE": {
      //   name: "PALISADE",
      //   nameTitle: "PALISADE",
      //   nameAlt: "PALISADE",
      //   preview: require('./../UI/carSlider/palisade_car.webp'),
      //   info: require('./../UI/carSlider/palisade_info.webp'),
      //   bgColor: '#2F2F2F'
      // },
      // "HB20": {
      //   name: "HB20",
      //   nameTitle: "HB20",
      //   nameAlt: "HB20",
      //   preview: require('./../UI/carSlider/HB20_car.webp'),
      //   info: require('./../UI/carSlider/HB20_info.webp'),
      //   bgColor: '#005073'
      // },
      // "HB20S": {
      //   name: "HB20S",
      //   nameTitle: "HB20S",
      //   nameAlt: "HB20S",
      //   preview: require('./../UI/carSlider/HB20S_car.webp'),
      //   info: require('./../UI/carSlider/HB20S_info.webp'),
      //   bgColor: '#929292'
      // },
      // "STARIA": {
      //   name: "STARIA",
      //   nameTitle: "STARIA",
      //   nameAlt: "STARIA",
      //   preview: require('./../UI/carSlider/staria_car.webp'),
      //   info: require('./../UI/carSlider/staria_info.webp'),
      //   bgColor: '#4F4F4F'
      // },
    }
  }
}